import { render, staticRenderFns } from "./Login2Fa.vue?vue&type=template&id=2da7fd8b"
import script from "./Login2Fa.vue?vue&type=script&lang=js"
export * from "./Login2Fa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports